module.exports = __webpack_public_path__ + "img/0ba032f.png";